module.exports = {
  stylePrefix: 'trt-',

  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  labelContainer: window.lang['componentSettings'] || '',

  // Placeholder label for text input types
  labelPlhText: 'np. Wpisz tekst tutaj',

  // Placeholder label for href input
  labelPlhHref: 'np. https://google.com',

  // Default options for the target input
  optionsTarget: [
    { value: '', name: 'W tym samym oknie' },
    { value: '_blank', name: 'Nowa zakładka' },
    { value: '_blank', name: 'Nowe okno' }
  ],

  // Text to show in case no element selected
  textNoElement: window.lang['selectElement'] || ''
};
